import React from 'react'
import CurrencyFormat from 'react-currency-format'
import '../../css/components/input/input.css'
import './style.css'

const InputTextBudget = ({ value, name, disabled, onChange, onBlur, onKeyPress, placeholder, className }) => {
  return (
    <div>
      <CurrencyFormat
        placeholder={placeholder || ''}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={1}
        fixedDecimalScale={true}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        disabled={disabled}
        className={`input-text input-text-budget text-center ${className}`}
        name={name}
      />
    </div>
  )
}

export default InputTextBudget